import { createContext, useContext } from "react";

/**
 * Provides a scoped HTMLElement for Radix portals (Dialog, Sheet) to render into.
 * When set, portaled content renders inside the scoped element instead of document.body,
 * so CSS variables scoped to the wrapper div are inherited by portaled overlays.
 *
 * Only used in portal-web's enduser portal and preview pane — admin UI does not set this.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null);

export const usePortalContainer = () => useContext(PortalContainerContext);
